<div class="header-container">
    <div class="search-box">
      <input
        type="text"
        placeholder="Search"
        [(ngModel)]="searchText"
        (keyup)="typed($event)" 
      />
      <i class="fa fa-search"></i>
    </div>
    
    <thera-button
     *ngIf="canAccess"
      class="mr-2"
      matTooltip="Only associated discipline allowed."
      [config]="{
        variant: buttonVariant.PRIMARY,
        text: 'Sign'
      }"
      [disabled]="!isEnable"
      (click)="onClickSign()"
    ></thera-button>
</div>
